import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Teamwork Collection (TWC) Trial — CollectionChangePlanPopup.
 * Shown to billing admins in a Jira or Confluence collection during trial
 * (when PDE has already been entered, i.e. not the no-PDE trial case).
 */
export function isEligibleForTWCChangePlan(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInCollection, isInTrial, userRoles } = context;

	return Boolean(
		isEditionOneOf(edition, ['standard', 'premium']) &&
		isInCollection &&
		isProductOneOf(product, ['jira', 'confluence']) &&
		userRoles?.includes('BILLING_ADMIN') &&
		isInTrial,
	);
}
